(function () {
    'use strict';
    angular.module('Login').controller('LoginController', LoginController);
    LoginController.$inject = [
        '$scope',
        '$cookies',
        'AuthenticationService',
        '$routeParams',
        'RememberMeService',
        '$uibModal'
    ];

    function LoginController(
        $scope,
        $cookies,
        AuthenticationService,
        $routeParams,
        RememberMeService,
        $uibModal
    ) {
        const refreshToken = $cookies.get('auth') ? $cookies.get('auth') : localStorage.getItem('auth');
        var authCookie = refreshToken || false;
        var getString = {};
        var search = window.location.search ? window.location.search.split('?')[1].split('&') : false;
        $scope.Company = {};

        $scope.login = login;
        $scope.rememberMeChanged = rememberMeChanged;

        init();

        function init() {
            var host = window.location.host.split('.')[1];
            switch (host) {
                case 'srktransport':
                    $scope.Company = {
                        logo: '/auth/images/login/srk-logo.png',
                        title: 'SRK',
                        name: 'srk',
                        link: 'http://srktransport.com.au/',
                        pageTitle: 'SRK Transport | Powered by BBA',
                        resellerId: resellerId.srk
                    }
                    break;
                case 'alfalogistics':
                    $scope.Company = {
                        logo: '/auth/images/login/alfa-logo.png',
                        title: 'ALFA',
                        name: 'alfa',
                        link: 'http://alfalogistics.com.au/',
                        pageTitle: 'Alfa Logistics Service | Powered by BBA',
                        resellerId: resellerId.alfa
                    };
                    break;
                default:
                    $scope.Company = {
                        logo: '/auth/images/login/bba_logo.png',
                        title: 'BBA Mastro',
                        name: 'bba',
                        link: 'http://bbamastro.com/',
                        pageTitle: 'BBA Mastro Service',
                        resellerId: resellerId.bba
                    };
                    break;
            }

            if ($routeParams.changed && $routeParams.changed == "changed") {
                $scope.resetPass = true;
            } else {
                $scope.resetPass = false;
            }

            $scope.showHideLgoinForm = false;
            search ? search.map(function (item) {
                var keyValue = item.split('=');
                getString[keyValue[0]] = keyValue[1];
            }) : false;
            if (authCookie) {
                window.location = getString.page ? decodeURIComponent(getString.page) : '/';
                return;
            }

            AuthenticationService.clearCredentials();
            $scope.dataLoading = false;
        }

        function login(form) {
            if ($scope.dataLoading) return;
            $scope.$broadcast('show-errors-check-validity');
            if ($scope.form.$valid) {
                $scope.authError = false;
                $scope.dataLoading = true;
                AuthenticationService.login($scope.username, $scope.password, $scope.Company, function (response) {

                    twoFactorAuthenticationValdation(response);

                    // setRememberMeTokens(response.data.refresh_token);
                    // window.location = getString.page ? decodeURIComponent(getString.page) : '/';
                }, function (error) {
                    $scope.authError = true;
                    $scope.dataLoading = false;

                    if (error.status === 503) {
                        $scope.message = error.statusText + ". Please try again later";
                    }
                    else {
                        $scope.message = generateErrorMessage(error.data.error_description);
                    }
                });
                return false;
            }
        }


        function twoFactorAuthenticationValdation(data) {
            AuthenticationService.validateMFA(res => {
                if (res.data.twoFactorStatus) {
                    if (res.data.remainDays < 0) {
                        twoFactorAuthentication(data, res.data);
                        return;
                    }
                }

                setRememberMeTokens(res.data.refresh_token);
                window.location = getString.go ? decodeURIComponent(getString.go) : '/';
            }, err => {
                console.log(err)
            })
        }

        function setRememberMeTokens(refreshToken) {
            if (RememberMeService.getRememberMe()) {
                RememberMeService.setRememberMeTokens(refreshToken);
            } else {
                RememberMeService.removeRememberMeTokens();
            }
        }

        function generateErrorMessage(message) {
            if (!message) {
                return 'Server is down. Please try again';
            }

            if (message.includes('does not exist!') || message.includes('locked')) {
                return 'Contact Support Helpdesk to Activate Account.';
            }
            return message;
        }

        function rememberMeChanged(isRememberMe) {
            RememberMeService.setRememberMe(isRememberMe);
        }

        function twoFactorAuthentication(data, authType) {
            $uibModal.open({
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '../auth/templates/modal/twoFactorAuthentication.html',
                controller: 'TwoFactorAuthModalController',
                controllerAs: 'vm',
                keyboard: false,
                backdrop: 'static',
                windowClass: 'login-modal',
                size: 'sm',
                resolve: {
                    data: () => {
                        return data;
                    },
                    authType: () => {
                        return authType;
                    }
                }
                //appendTo: $('body')
            }).result.then(response => {
                if (response) {
                    setRememberMeTokens(data.data.refresh_token);
                    window.location = getString.go ? decodeURIComponent(getString.go) : '/';
                    return;
                }
                $scope.dataLoading = false;

            })
        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./auth/js/controllers/LoginController.js
// module id = 145
// module chunks = 0